var Ota = /** @class */ (function () {
    function Ota(props) {
        Object.assign(this, props);
        if (props.created_at) {
            this.created_at = new Date(props.created_at);
        }
        if (props.disabled_at) {
            this.disabled_at = new Date(props.disabled_at);
        }
    }
    return Ota;
}());
export default Ota;
export var TuritopKeys = Object.freeze([
    'TURITOP_SHORT_ID',
    'TURITOP_SECRET_KEY',
    'TURITOP_SHORT_ID_SANDBOX',
    'TURITOP_SECRET_KEY_SANDBOX'
]);
export var FareharborKeys = Object.freeze([
    'FAREHARBOR_SHORT_NAME',
    'FAREHARBOR_APP_TOKEN',
    'FAREHARBOR_USER_TOKEN',
    'FAREHARBOR_SHORT_NAME_SANDBOX',
    'FAREHARBOR_APP_TOKEN_SANDBOX',
    'FAREHARBOR_USER_TOKEN_SANDBOX'
]);
export var otas = Object.freeze({
    Fareharbor: 'Fareharbor',
    Turitop: 'Turitop',
});
export var OtasKeys = Object.freeze({
    Turitop: TuritopKeys,
    Fareharbor: FareharborKeys,
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Otas/Ota.ts
// module id = 731
// module chunks = 0